import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { UnoStoreHooks, unoStore } from "@simulanisindia/ui";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./Store/store";
import { BrowserRouter } from "react-router-dom";

const { UnoProvider } = UnoStoreHooks;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UnoProvider store={unoStore}>
    <Provider store={store}>
      {/* <React.StrictMode> */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      {/* </React.StrictMode> */}
    </Provider>
  </UnoProvider>
);
